import React, { useEffect, useState } from "react";
import { DateRangeBarChart } from "../../Component/Analytics/DateRangeBarChart";
import AnalyticsDataService from "../../services/analytics";
import { DateTime } from "luxon";
import {
  Box,
  Button,
  Heading,
  Select,
  VStack,
  HStack,
  Text,
  Input,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";

import {
  graphOptions,
  countTypeOptions,
  categoryOptions,
  leadSourceOptions,
} from "../../Config/graphfilter";
import { DateRangeLineChart } from "../../Component/Analytics/DateRangeLineChart";
import { MultiSelect } from "react-multi-select-component";

export const ContactRecords = () => {
  const platformOptions = [
    { value: "WEB", label: "Web" },
    { value: "APP", label: "App" },
    { value: "OTHER", label: "Other" },
  ];

  const firstDayOfMonth = DateTime.now().startOf("month").toISODate();

  const yesterday = DateTime.now().minus({ days: 1 }).toISODate();

  const [platforms, setPlatforms] = useState<any[]>(["WEB", "APP", "OTHER"]);
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(yesterday);
  const [category, setCategory] = useState("HOT");

  const [graphType, setGraphType] = useState("bar");
  const [countType, setCountType] = useState("daily");

  const [leadSource, setLeadSource] = useState(
    graphType === "line" ? "EHC" : ""
  );

  const [countData, setCountData] = useState<any>([]);

  const fetchContactGraphs = () => {
    AnalyticsDataService.getContactStatusCount(
      startDate,
      endDate,
      leadSource,
      platforms
    )
      .then((res: any) => {
        if (countType === "daily") {
          const data = res.data.map((item: any) => {
            return {
              date: item.date,
              ...item.dailyCounts,
            };
          });
          setCountData(data);
        } else {
          const data = res.data.map((item: any) => {
            return {
              date: item.date,
              ...item.totalCounts,
            };
          });
          setCountData(data);
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchContactGraphs();
  }, [
    startDate,
    endDate,
    countType,
    graphType,
    category,
    platforms,
    leadSource,
  ]);

  useEffect(() => {
    if (graphType === "bar") {
      setLeadSource("");
    } else if (graphType === "line") {
      setLeadSource("EHC");
    }
  }, [graphType]);

  return (
    <>
      <Box
        bg="#e98b90"
        color="white"
        fontWeight="bold"
        textAlign="center"
        textColor="black"
        py={4}
        px={6}
      >
        Contacts
      </Box>
      <Box p={6} maxW="100%" bg="gray.50">
        <VStack align="start" spacing={4}>
          <HStack spacing={8} align="center">
            <Text fontSize="lg" fontWeight="semibold">
              From
            </Text>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />

            <Text fontSize="lg" fontWeight="semibold">
              To
            </Text>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              max={DateTime.now().toISODate()}
            />
          {/* </HStack> */}
          {/* <HStack spacing={8} align="center"> */}
            {/* <Select
              placeholder="Select Graph"
              value={graphType}
              minW="120px"
              onChange={(e) => setGraphType(e.target.value)}
            >
              {graphOptions.map((item: any, index: any) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Select> */}

            <Select
              placeholder="Select Count Type"
              value={countType}
              onChange={(e) => setCountType(e.target.value)}
            >
              {countTypeOptions.map((item: any, index: any) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Select>

            {graphType === "bar" && (
              <Select
                placeholder="Select Category"
                value={category}
                minW="180px"
                onChange={(e) => setCategory(e.target.value)}
              >
                {categoryOptions.map((item: any, index: any) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>
            )}

            {graphType === "line" && (
              <Select
                placeholder="Select Lead Source"
                value={leadSource}
                minW="200px"
                onChange={(e) => setLeadSource(e.target.value)}
              >
                {leadSourceOptions.map((item: any, index: any) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>
            )}

            <MultiSelect
              options={platformOptions}
              labelledBy="Select Platforms"
              value={platformOptions.filter((opt) =>
                platforms.includes(opt.value)
              )}
              onChange={(selected: any) =>
                setPlatforms(selected.map((opt: any) => opt.value))
              }
            />
          </HStack>

          <Box w="100%" mt={6}>
            {/* {countData.length > 0 && graphType === "bar" ? ( */}
            <DateRangeBarChart
              data={countData}
              xKey="date"
              barKey={category}
              isSessionCount={false}
            />
            {/* ) : (
              <DateRangeLineChart data={countData} />
            )} */}
          </Box>
        </VStack>
      </Box>
    </>
  );
};
